import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { NestingRunView } from "shared";

import { layoutNestingQuery, setLayoutNestingQueryData } from "../infra/layoutNesting.query";
import { runLayoutNesting } from "../infra/runLayoutNesting.api";

export const useRunLayoutNesting = (
  layoutId: string,
  options?: { onError?: (err: unknown) => void },
) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation<NestingRunView>({
    mutationFn: () => runLayoutNesting(layoutId),
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey: layoutNestingQuery(layoutId).queryKey });
    },
    onSuccess: (nestingRun) => {
      setLayoutNestingQueryData(queryClient, layoutId, nestingRun);
    },
    onError: (err: unknown) => {
      options?.onError?.(err);
      errorHandler(err);
    },
  });

  return { runLayoutNesting: mutate, ...rest };
};
